module.exports = __webpack_public_path__ + "static/media/PCA_m_dark_long.7c238fd0.svg";